import { atom } from 'jotai'
import type { UserProfile } from '@app/types'

export const userToRemoveAtom = atom<UserProfile | null>(null)

userToRemoveAtom.debugLabel = 'userToRemoveAtom'
